import {SALES_TAX} from "../../client_customizations/data/assumptions/ASSUMPTIONS";

export default (priceWithoutTax) => {
    return priceWithoutTax * (1 + SALES_TAX.value);
}